/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { makeStyles } from "@material-ui/core/styles";
import Actions from "./../../fluid/Actions/ActionFactory";
import ErrorMessageAlert from "../Utilities/ErrorMessageAlert";
import { isValidURL, containsIpAddress } from "./../Utilities/validate";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";

export default function AddWebService({ open, handleClose }) {
  const [name, setName] = React.useState("");
  const [description, setDescription] = React.useState("");

  const [url, setUrl] = React.useState("");
  const [urlError, setUrlError] = React.useState(false);
  const [urlHelperText, setUrlHelperText] = useState("");

  const [errorOpen, setErrorOpen] = React.useState(false);
  const [errorInfo, setErrorInfo] = useState({});

  const [isLoading, setIsLoading] = useState(false);
  const descriptionMaxLength = 1080;
  const nameMaxLength = 256;

  const useStyles = makeStyles((theme) => ({
    backdrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: "#fff",
    },
    text_field_root: {
      display: "block",
      width: "60%",
    },
  }));

  const clearFields = () => {
    setName("");
    setDescription("");

    setUrl("");
    setUrlError(false);
    setUrlHelperText("");

    setIsLoading(false);
    setErrorInfo({});
  };

  const handleCancel = () => {
    clearFields();
    handleClose({ refreshList: false });
  };

  const handleSubmit = () => {
    //check if url field contains any IP address in it.
    // if (containsIpAddress(url)) {
    //   setUrlError(true);
    //   setUrlHelperText(
    //     "Web Service URL cannot contain IP address, Please use a hostname instead."
    //   );
    //   return;
    // }
    //check if URL is valid or not
    if (!isValidURL(url)) {
      setUrlError(true);
      setUrlHelperText("Please enter a valid URL.");
      return;
    }
    setUrlError(false);
    setUrlHelperText("");
    setIsLoading(true);
    //register web-service
    Actions("http_request", {
      url: "/sainapse/web_service",
      method: "post",
      data: {
        name: name,
        description: description,
        url: url,
      },
    })
      .then((response) => {
        console.log("res edge", response);
        setName(response.data.result.name);
        setIsLoading(false);
        clearFields();
        handleClose({ refreshList: true });
      })
      .catch((err) => {
        setIsLoading(false);
        setErrorOpen(true);
        setErrorInfo(err);
      });
  };
  const classes = useStyles();
  const handleErrorClose = () => {
    setErrorOpen(false);
    setErrorInfo("");
  };

  return (
    <>
      <Dialog
        open={open}
        // onClose={handleAddWebServiceClose}
        aria-labelledby="form-dialog-title"
        id="add-web-service"
        maxWidth="xl"
      >
        <Backdrop className={classes.backdrop} open={isLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <DialogTitle id="form-dialog-title">Add Web Service</DialogTitle>
        <DialogContent style={{ width: "60vw" }}>
          <DialogContentText>
            To add a new web service ,please fill out the following fields.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="web-service-name"
            label="Web Service Name"
            type="text"
            value={name}
            fullWidth={true}
            onChange={(event) => {
              setName(
                event.target.value.substring(
                  0,
                  Math.min(event.target.value.length, nameMaxLength)
                )
              );
            }}
            classes={{
              root: classes.text_field_root,
            }}
          />
          <TextField
            margin="dense"
            id="web-service-description"
            label="Web Service Description"
            type="text"
            value={description}
            fullWidth={true}
            onChange={(event) => {
              setDescription(
                event.target.value.substring(
                  0,
                  Math.min(event.target.value.length, descriptionMaxLength)
                )
              );
            }}
            multiline={true}
            rowsMax="4"
            classes={{
              root: classes.text_field_root,
            }}
          />
          <TextField
            error={urlError}
            margin="dense"
            id="web-service-url"
            label="Web Service URL"
            type="url"
            value={url}
            fullWidth={true}
            onChange={(event) => setUrl(event.target.value)}
            classes={{
              root: classes.text_field_root,
            }}
            helperText={urlHelperText}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCancel} color="primary" variant="contained">
            Cancel
          </Button>
          <Button onClick={handleSubmit} color="primary" variant="contained">
            Submit
          </Button>
        </DialogActions>
      </Dialog>
      <ErrorMessageAlert
        open={errorOpen}
        handleClose={handleErrorClose}
        errorInfo={errorInfo}
      ></ErrorMessageAlert>
    </>
  );
}
